<!--  -->
<template>
    <div class="successH5">
        <div class="successH5-container">
            <div class="successH5-icon">
                <svg viewBox="0 0 100 100">
                    <circle cx="50" cy="50" r="45" fill="#e8f4ff" stroke="none" />
                    <path fill="none" stroke="var(--primary)" stroke-width="6" stroke-linecap="round"
                        stroke-linejoin="round" d="M30 52l15 15 25-25" style="stroke-dasharray: 100;
                             stroke-dashoffset: 100;
                             animation: checkmark 0.8s ease-out forwards;
                             animation-delay: 0.3s" />
                </svg>
            </div>

            <h1 class="successH5-title">提交成功!</h1>

            <p class="successH5-message">
                问卷提交成功！我们已成功收到您的问卷反馈。
            </p>
<!-- 
            <div class="action-buttons">
                <a href="https://www.bjia.org/" class="btn">
                    <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                        <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
                    </svg>
                    返回首页
                </a>
            </div> -->
        </div>
    </div>
</template>

<script>
    export default {
        name: 'successH5',
        data() {
            //这里存放数据
            return {

            }
        },
        components: {},

        //方法集合
        methods: {
            beforeDestroy() {
                // 在组件销毁时移除 meta 标签
                const meta = document.querySelector('meta[name="viewport"]');
                if (meta) {
                    document.head.removeChild(meta);
                }
            }
        },
        created() {

        },
        mounted() {
             document.title='调查问卷'
            const meta = document.createElement('meta');
            meta.name = 'viewport';
            meta.content = 'width=device-width, initial-scale=1.0, user-scalable=no';
        }
    }
</script>
<style>
    :root {
        --primary: #4179d2;
        --light-bg: #f8f9fc;
    }

    .successH5 {
        max-width: 100vw;
        margin: 0;
        min-height: 100vh;
        display: flex;
        align-items: center;
        background: var(--light-bg);
        font-family: 'Microsoft YaHei', sans-serif;
    }

    .successH5-container {
        width: 80vw;
        margin: 0.5rem auto;
        padding: 0.5rem;
        text-align: center;
        background: white;
        border-radius: 30px;
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08);
        position: relative;
    }

    .successH5-icon {
        width: 3rem;
        height: 3rem;
        margin: 0.6rem auto;
        animation: float 3s ease-in-out infinite;
    }

    @keyframes float {

        0%,
        100% {
            transform: translateY(0);
        }

        50% {
            transform: translateY(-8px);
        }
    }

    @keyframes checkmark {
        from {
            stroke-dashoffset: 100;
        }

        to {
            stroke-dashoffset: 0;
        }
    }

    .successH5-title {
        font-size: 0.8rem;
        color: #1a237e;
        padding-left: 0.5rem;
        margin-bottom: 0.5rem;
        font-weight: 600;
    }

    .successH5-message {
        color: #616161;
        font-size: 0.4rem;
        line-height: 0.55rem;
        margin: 0 auto 0.3rem;
        /* max-width: 480px; */
    }

    .action-buttons {
        display: flex;
        justify-content: center;
    }

    .btn {
        padding: 0.3rem 0.6rem;
        /* padding: 0.9rem 2.5rem; */
        border-radius: 8px;
        text-decoration: none;
        font-weight: 500;
        transition: all 0.2s;
        background: var(--primary);
        color: white;
        box-shadow: 0 4px 14px rgba(65, 121, 210, 0.3);
        border: none;
        display: inline-flex;
        align-items: center;
        gap: 8px;
    }

    .btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(65, 121, 210, 0.4);
    }
</style>